<template>
  <button
    :class="['button', 'is-primary', 'is-fullwidth', { 'is-loading': loading }]"
    @click="createAsyncCase()"
  >
    {{ buttonText }}
  </button>
</template>

<script>
import InterviewsService from "@/services/InterviewsService";
import VisuwellService from '@/services/VisuwellService';
import { redirectToVisuwell } from "../../helpers/visuwell";

export default {
  name: "AsyncButton",

  props: {
    question: Object,
    buttonText: String,
    organizationId: String
  },

  data() {
    return {
      loading: false
    };
  },

  computed: {
    answers() {
      return this.$store.state.interview.answers;
    },
    interviewId() {
      return this.$store.state.interview.id;
    },
    patientQueueId() {
      return this.$store.state.interview.patientQueue.id;
    },
    referrer() {
      return this.$store.getters["interview/getReferrer"];
    },
    patient() {
      return this.$store.getters["interview/getPatient"];
    },
  },

  methods: {
    createAsyncCase() {
      this.loading = true;

      InterviewsService.finish_and_create_async_case(
        this.interviewId,
        this.patientQueueId,
        this.answers,
        {
          referrer: this.referrer,
          patient: this.patient
        },
        this.organizationId
      )
        .then(({ submitted, response }) => {
          if (submitted && response && response.data ) {
            if (response.data['login_with'] && response.data['redirect_to']) {
              VisuwellService.login(response.data['login_with'], response.data['redirect_to']).then(
                redirectToVisuwell
              );
            } else if (response.data['redirect_to']) {
              window.location = response.data['redirect_to']
            } else {
              this.loading = false;
              this.message =
                "Sorry, we could not process your request. Please try again.";
            }
          } else {
            this.loading = false;
            this.message =
              "Sorry, we could not process your request. Please try again.";
          }
        })
        .catch(error => {
          console.error(error)
          this.loading = false;
          this.message = `Sorry, we could not process your request. ${error.response.data.errors[0].detail}`;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
